var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _path2, _rect7, _rect8, _rect9, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPainAttendance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 26,
    width: 92,
    height: 104,
    rx: 12,
    fill: "#F7F2EA",
    stroke: "#E4DCCF",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 18,
    width: 20,
    height: 14,
    rx: 4,
    fill: "#CBD2DC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 13,
    width: 12,
    height: 10,
    rx: 3,
    fill: "#EEF0F4",
    stroke: "#CBD2DC",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 48,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#FEF4E3",
    stroke: "#F59E0B",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 56l3 3 5-6",
    stroke: "#F59E0B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 53,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#E7EAEF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 76,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#FEF4E3",
    stroke: "#F59E0B",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 84l3 3 5-6",
    stroke: "#F59E0B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 81,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#E7EAEF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 104,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#FFFFFF",
    stroke: "#CBD2DC",
    strokeWidth: 2.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 109,
    width: 30,
    height: 6,
    rx: 3,
    fill: "#EDEFF3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 50,
    r: 18,
    fill: "#FFFFFF",
    stroke: "#F59E0B",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158 41v10l6 4",
    stroke: "#F59E0B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainAttendance);
export default __webpack_public_path__ + "static/media/pain-attendance.6348455ad8196de04fe36588c8a0c62e.svg";
export { ForwardRef as ReactComponent };